import axios from 'axios';

import { UNDERWRITING_API_URL } from 'constants/api';

const underwritingAPI = axios.create({
  baseURL: UNDERWRITING_API_URL,
});

export default underwritingAPI;
